import React from 'react';
import { useHistory } from 'react-router-dom';
import permissionConstants from '../../constants/permission.constans';
import routeConstant from '../../constants/route.constants';
import { checkPermissons } from '../../helper/check-permission';
import './global-header.scss';
import Logo from '../../assets/img/logo_big.png';
import DropdownMenu from './DropdownMenu';
import { useDispatch } from 'react-redux';
import { setTreeData } from '../../components/familytree/scripts/tree-slice';
import { getCurrentTreeDataText } from '../../components/familytree/scripts/cy-core';

const GlobalHeader = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <div className="global-header-root">
      <img className="logo" alt="logo" src={Logo} />
      <ul className="menu">
        <li
          // style={{
          //   display: checkPermissons([permissionConstants.DASHBOARD]) ? null : 'none',
          // }}
          className={`menu-item ${
            window.location.pathname.includes(routeConstant.DASH_BOARD) ? 'active' : ''
          }`}
        >
          <div
            onClick={() => {
              history.push(routeConstant.DASH_BOARD);
            }}
          >
            Home
          </div>
        </li>
        {checkPermissons([permissionConstants.USERS_MANAGEMENT]) && (
          <li
            className={`menu-item ${
              window.location.pathname.includes(routeConstant.USER_MANAGEMENT) ? 'active' : ''
            }`}
          >
            <div
              onClick={() => {
                dispatch(setTreeData(getCurrentTreeDataText()));
                history.push(routeConstant.USER_MANAGEMENT);
              }}
            >
              User Management
            </div>
          </li>
        )}

        <li
          // style={{
          //   display: checkPermissons([permissionConstants.DASHBOARD]) ? null : 'none',
          // }}
          className={`menu-item ${
            window.location.pathname.includes(routeConstant.FULL_TREE) ? 'active' : ''
          }`}
        >
          <div
            onClick={() => {
              dispatch(setTreeData(getCurrentTreeDataText()));
              history.push(routeConstant.FULL_TREE);
            }}
          >
            Full screen
          </div>
        </li>
        <li
          style={{
            display: checkPermissons([
              permissionConstants.EMAIL_TEMPLATE,
              permissionConstants.EMAIL_NOTIFICATION,
            ])
              ? null
              : 'none',
          }}
          className={`menu-item ${
            window.location.pathname.includes(routeConstant.EMAIL_NOTIFICATION) ? 'active' : ''
          }`}
        >
          <div
            onClick={() => {
              dispatch(setTreeData(getCurrentTreeDataText()));
              history.push(routeConstant.EMAIL_NOTIFICATION);
            }}
          >
            Email Notification
          </div>
        </li>

        <li
          className={`menu-item ${
            window.location.pathname.includes(routeConstant.GUIDE) ? 'active' : ''
          }`}
        >
          <div
            onClick={() => {
              dispatch(setTreeData(getCurrentTreeDataText()));
              history.push(routeConstant.GUIDE);
            }}
          >
            Hướng dẫn
          </div>
        </li>
      </ul>

      <DropdownMenu />
    </div>
  );
};

export default GlobalHeader;
